<template>
   <v-container>
      <v-dialog
         v-model="dialog"
         persistent
         hide-overlay
         height="300px"
         width="300px"
      >
         <v-row justify="center" height="300px">
            <v-col cols="4" md="4" class="flex d-flex flex-column">
               <v-overlay value="apiCall" opacity="0.3">
                  <v-progress-circular color="red darken-1" indeterminate>
                  </v-progress-circular>
               </v-overlay>
            </v-col>
         </v-row>
      </v-dialog>
   </v-container>
</template>

<script>
   export default {
      props: {
         apiCall: Boolean,
      },

      data() {
         return {
            dialog: this.apiCall,
         };
      },
      watch: {
         apiCall: function(newval, oldval) {
            this.dialog = newval;
         },
      },
   };
</script>
